// --- Generation Sources ---
export enum GenerationSource {
  IMAGE_GENERATION = "image_generation",
  VIDEO_GENERATION = "video_generation",
  EFFECTS = "effects",
  PHOTOSHOOT = "photoshoot",
  HISTORY_EDIT = "history_edit",
  MODEL_PAGE = "model_page",
  BACKGROUND_REMOVAL = "background_removal",
  UPSCALE = "upscale",
  VIRTUAL_TRY_ON = "virtual_try_on",
  BABY_DANCE = "baby_dance",
  MOTION_FLOW = "motion_flow",
  PROFESSIONAL_HEADSHOT = "professional_headshot",
  MUSIC_GENERATION = "music_generation",
  API = "api",
  TELEGRAM_MINIAPP = "telegram_miniapp",
  TELEGRAM_BOT = "telegram_bot",
  UNKNOWN = "unknown"
}
